import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LogoComponent } from '../../_shared/logo/logo.component';
import { KtidentityService } from '../../_services/ktidentity.service';

/**
 * Confirmação do vínculo da conta do Cognito com o KTIdentity, aberta pelo link do e-mail.
 * Só confirma no clique, nunca ao carregar: scanners de e-mail que abrem o link não gastam o token.
 * Não abre sessão; depois de confirmar, a pessoa entra pelo botão do KTIdentity.
 */
@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule, LogoComponent],
  selector: 'app-ktidentity-link',
  templateUrl: './ktidentity-link.component.html',
  styleUrls: ['../ktidentity-reset-password/ktidentity-reset-password.component.scss']
})
export class KtidentityLinkComponent implements OnInit, OnDestroy {
  state: 'pending' | 'confirmed' | 'invalid' | 'error' = 'pending';
  submitting = false;

  private token = '';

  constructor(
    private route: ActivatedRoute,
    private ktidentityService: KtidentityService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    document.body.className = 'hold-transition login-page';
    this.token = this.route.snapshot.paramMap.get('token') || '';
  }

  ngOnDestroy(): void {
    document.body.className = '';
  }

  confirm(): void {
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    this.ktidentityService.confirmLink(this.token).subscribe(() => {
        this.submitting = false;
        this.state = 'confirmed';
      },
      error => {
        this.submitting = false;
        const code = error?.error?.code;
        this.state = code === 'link_invalid' || code === 'invalid_request' ? 'invalid' : 'error';
      }
    );
  }
}
